// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasks-tab .task-details-tab-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  max-width: 996px;
}
.tasks-tab .task-details-tab-content .forms-list-tab {
  padding: 0;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-list-tab-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-list-tab-header h1 {
  font-size: 30px;
  font-weight: 700;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-list-tab-header .forms-list-header-actions {
  display: flex;
  gap: 8px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-list-tab-header .forms-list-header-actions .task-actions-btn,
.tasks-tab .task-details-tab-content .forms-list-tab .forms-list-tab-header .forms-list-header-actions .add-form-btn {
  height: 44px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-list-tab-header .forms-list-header-actions .task-actions-btn {
  width: 44px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-list-tab-header .forms-list-header-actions .dropdown-menu {
  padding: 5px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table {
  margin-top: 24px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .th {
  padding: 13px 24px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr:hover .col-name-right {
  visibility: visible !important;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr .td {
  padding: 14px 20px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr .td .col-name {
  display: flex;
  justify-content: space-between;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr .td .col-name .col-name-left {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #101828;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr .td .col-name .col-name-left img {
  margin-right: 4px;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr .td .col-name .col-name-right {
  display: flex;
  align-items: center;
  visibility: hidden;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr .td .col-name .col-name-right .delete-form-button {
  height: 40px;
  width: 40px;
  display: block;
  cursor: pointer;
}
.tasks-tab .task-details-tab-content .forms-list-tab .forms-table .tr .td .col-name .col-name-right .delete-form-button i::before {
  color: #667085 !important;
}
.tasks-tab .task-details-tab-content .d-flex {
  display: flex;
  margin-bottom: 30px;
}
.tasks-tab .task-details-tab-content .d-flex .form-control-radio {
  margin-right: 44px;
}
.tasks-tab .task-details-tab-content .d-flex .form-control-radio:first-child {
  width: 145px;
}
.tasks-tab .task-details-tab-content .d-flex .form-control-radio:nth-child(2) {
  width: 145px;
}
.tasks-tab .task-details-tab-content .select-multy-wrapper {
  position: relative;
}
.tasks-tab .task-details-tab-content .select-multy-wrapper .select-placeholder {
  position: absolute;
  top: 13px;
  left: 15px;
  z-index: 2;
  pointer-events: none;
  color: #a0abc0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
}
.tasks-tab .task-details-tab-content .form-control-select .react-select-multi__control {
  height: 48px;
  position: relative;
}
.tasks-tab .task-details-tab-content .form-control-select .react-select-multi__control .css-1p3m7a8-multiValue {
  display: none;
}
.tasks-tab .task-details-tab-content .form-control-radio {
  margin-bottom: 0;
}
.tasks-tab .task-details-tab-content .task-settings-tab {
  overflow: scroll;
  height: calc(100vh - 80px - 71px - 60px);
  scrollbar-width: none;
}
.tasks-tab .task-details-tab-content .task-settings-tab h1 {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 27px;
}
.tasks-tab .task-details-tab-content .task-settings-tab .form-control-item-settings {
  display: flex;
}
.tasks-tab .task-details-tab-content .task-settings-tab .form-control-item-settings .form-label-big {
  font-size: 16px;
}
.tasks-tab .task-details-tab-content .task-settings-tab .form-control-item-group {
  margin-bottom: 28px;
}
.tasks-tab .task-details-tab-content .task-settings-tab.form-init-settings {
  padding-bottom: 80px;
}
.tasks-tab .task-details-tab-content .task-settings-tab.form-init-settings .form-settings-label {
  width: 604px;
}
.tasks-tab .task-details-tab-content .task-settings-tab .form-settings-label {
  width: 471px;
}
.tasks-tab .task-details-tab-content .task-settings-tab .form-settings-label span {
  color: var(--secondary-text, #667085);
  font-size: 14px;
}
.tasks-tab .task-details-tab-content .task-settings-tab .form-settings-inputs {
  width: 100%;
  padding-left: 24px;
}
.tasks-tab .task-details-tab-content .task-settings-tab .form-settings-inputs.disabled {
  opacity: 0.6;
  pointer-events: none;
}
.tasks-tab .task-details-tab-content .form-control-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #cbd2e0;
  padding: 28px 0 0;
  height: 71px;
}
.tasks-tab .task-details-tab-content .form-control-actions .btn-outline:not(:last-child) {
  margin-right: 18px;
}`, "",{"version":3,"sources":["webpack://./src/pages/tasks/task-detail-page/styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AACM;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AACR;AACQ;EACE,eAAA;EACA,gBAAA;AACV;AAEQ;EACE,aAAA;EACA,QAAA;AAAV;AAEU;;EAEE,YAAA;AAAZ;AAGU;EACE,WAAA;AADZ;AAIU;EACE,YAAA;AAFZ;AAOM;EACE,gBAAA;AALR;AAOQ;EACE,kBAAA;AALV;AAUY;EACE,8BAAA;AARd;AAYU;EACE,kBAAA;AAVZ;AAYY;EACE,aAAA;EACA,8BAAA;AAVd;AAYc;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAVhB;AAYgB;EACE,iBAAA;AAVlB;AAcc;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAZhB;AAcgB;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAZlB;AAakB;EACE,yBAAA;AAXpB;AAqBI;EACE,aAAA;EACA,mBAAA;AAnBN;AAqBM;EACE,kBAAA;AAnBR;AAqBQ;EACE,YAAA;AAnBV;AAsBQ;EACE,YAAA;AApBV;AAyBI;EACE,kBAAA;AAvBN;AAyBM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAvBR;AA2BI;EACE,YAAA;EACA,kBAAA;AAzBN;AA2BM;EACE,aAAA;AAzBR;AA6BI;EACE,gBAAA;AA3BN;AA8BI;EACE,gBAAA;EACA,wCAAA;EACA,qBAAA;AA5BN;AA8BM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AA5BR;AA+BM;EACE,aAAA;AA7BR;AA+BQ;EACE,eAAA;AA7BV;AAiCM;EACE,mBAAA;AA/BR;AAkCM;EACE,oBAAA;AAhCR;AAkCQ;EACE,YAAA;AAhCV;AAoCM;EACE,YAAA;AAlCR;AAoCQ;EACE,qCAAA;EACA,eAAA;AAlCV;AAsCM;EACE,WAAA;EACA,kBAAA;AApCR;AAsCQ;EACE,YAAA;EACA,oBAAA;AApCV;AAyCI;EACE,aAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;AAvCN;AAyCM;EACE,kBAAA;AAvCR","sourcesContent":[".tasks-tab {\n  .task-details-tab-content {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n    max-width: 996px;\n\n    .forms-list-tab {\n      padding: 0;\n      .forms-list-tab-header {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n\n        h1 {\n          font-size: 30px;\n          font-weight: 700;\n        }\n\n        .forms-list-header-actions {\n          display: flex;\n          gap: 8px;\n\n          .task-actions-btn,\n          .add-form-btn {\n            height: 44px;\n          }\n\n          .task-actions-btn {\n            width: 44px;\n          }\n\n          .dropdown-menu {\n            padding: 5px;\n          }\n        }\n      }\n\n      .forms-table {\n        margin-top: 24px;\n\n        .th {\n          padding: 13px 24px;\n        }\n\n        .tr {\n          &:hover {\n            .col-name-right {\n              visibility: visible !important;\n            }\n          }\n\n          .td {\n            padding: 14px 20px;\n\n            .col-name {\n              display: flex;\n              justify-content: space-between;\n\n              .col-name-left {\n                display: flex;\n                align-items: center;\n                font-size: 14px;\n                line-height: 20px;\n                font-weight: 500;\n                color: #101828;\n\n                img {\n                  margin-right: 4px;\n                }\n              }\n\n              .col-name-right {\n                display: flex;\n                align-items: center;\n                visibility: hidden;\n\n                .delete-form-button {\n                  height: 40px;\n                  width: 40px;\n                  display: block;\n                  cursor: pointer;\n                  i::before {\n                    color: #667085 !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .d-flex {\n      display: flex;\n      margin-bottom: 30px;\n\n      .form-control-radio {\n        margin-right: 44px;\n\n        &:first-child {\n          width: 145px;\n        }\n\n        &:nth-child(2) {\n          width: 145px;\n        }\n      }\n    }\n\n    .select-multy-wrapper {\n      position: relative;\n\n      .select-placeholder {\n        position: absolute;\n        top: 13px;\n        left: 15px;\n        z-index: 2;\n        pointer-events: none;\n        color: #a0abc0;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: -0.16px;\n      }\n    }\n\n    .form-control-select .react-select-multi__control {\n      height: 48px;\n      position: relative;\n\n      & .css-1p3m7a8-multiValue {\n        display: none;\n      }\n    }\n\n    .form-control-radio {\n      margin-bottom: 0;\n    }\n\n    .task-settings-tab {\n      overflow: scroll;\n      height: calc(100vh - 80px - 71px - 60px); // 80 - header, 71 - footer actions, 60 - padding\n      scrollbar-width: none;\n\n      h1 {\n        font-size: 30px;\n        font-weight: 700;\n        margin-bottom: 27px;\n      }\n\n      .form-control-item-settings {\n        display: flex;\n\n        .form-label-big {\n          font-size: 16px;\n        }\n      }\n\n      .form-control-item-group {\n        margin-bottom: 28px;\n      }\n\n      &.form-init-settings {\n        padding-bottom: 80px;\n\n        .form-settings-label {\n          width: 604px;\n        }\n      }\n\n      .form-settings-label {\n        width: 471px;\n\n        span {\n          color: var(--secondary-text, #667085);\n          font-size: 14px;\n        }\n      }\n\n      .form-settings-inputs {\n        width: 100%;\n        padding-left: 24px;\n\n        &.disabled {\n          opacity: 0.6;\n          pointer-events: none;\n        }\n      }\n    }\n\n    .form-control-actions {\n      display: flex;\n      justify-content: flex-end;\n      border-top: 1px solid #cbd2e0;\n      padding: 28px 0 0;\n      height: 71px;\n\n      .btn-outline:not(:last-child) {\n        margin-right: 18px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
